import HeroSection from "./components/HeroSection";
import FeaturedSection from "./components/FeaturedSection";
import CategoryNav from "./components/CategoryNav";
import LatestUpdates from "./components/LatestUpdates";
import FAQSection from "./components/FAQSection";
import { useEffect } from "react";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "玫瑰视频",
  url: typeof window !== "undefined" ? window.location.origin : "",
  description: "玫瑰视频提供红桃视频、樱桃视频、茄子视频、糖心视频等平台高清资源，免费在线观看不缓冲，最新电视剧全集和电影大全一网打尽。",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: "/category/all?q={search_term_string}",
    },
    "query-input": "required name=search_term_string",
  },
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "首页",
      item: typeof window !== "undefined" ? window.location.origin : "",
    },
  ],
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "玫瑰视频是否需要注册才能观看？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "不需要！玫瑰视频所有内容完全免费，无需注册即可在线观看。",
      },
    },
    {
      "@type": "Question",
      name: "为什么玫瑰视频播放不会缓冲卡顿？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "玫瑰视频采用了先进的CDN加速技术和智能码率适配系统，确保流畅观影体验。",
      },
    },
    {
      "@type": "Question",
      name: "玫瑰视频的资源更新速度如何？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "玫瑰视频与主流平台保持同步更新，最新内容24小时内完成资源同步。",
      },
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const schemas = [homeSchema, breadcrumbSchema, faqSchema];
    schemas.forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      return () => {
        document.head.removeChild(script);
      };
    });
  }, []);

  return (
    <>
      <HeroSection />
      <FeaturedSection />
      <CategoryNav />
      <LatestUpdates />
      <FAQSection />
    </>
  );
}